import { IconDefinition } from '@fortawesome/fontawesome-common-types';
export class MailingSkillTreeItem {
   skillId: number;
   displayName: string;
   groupKey: string;
   groupName: string;
   children: MailingSkillTreeItem[] = null;
   showActiveState: boolean;
   icon: IconDefinition;
   constructor(
      skillId = null,
      displayName = '',
      groupName = null,
      children: MailingSkillTreeItem[] = null,
      icon: IconDefinition = null,
      showActiveState: boolean = false
   ) {
      this.skillId = skillId;
      this.displayName = displayName;
      this.groupName = groupName;
      this.children = children;
      this.showActiveState = showActiveState;
      this.icon = icon;
      this.groupKey = this.groupName + (this.skillId > 0 ? '_' + this.skillId : '');
   }
}
